module.exports = __webpack_public_path__ + "img/appointment.839af20c.svg";